<template>
  <v-dialog
    :model-value="modelValue"
    width="1000"
    @update:model-value="onDialogVisibility"
    @click:outside="closeModal"
  >
    <v-card rounded="lg">
      <div class="bg-red-600 relative py-5">
        <i
          class="mdi mdi-close text-xl cursor-pointer text-white absolute top-2 right-3"
          @click="closeModal"
        ></i>
        <h2 class="text-xl font-semibold text-white pl-10">
          Request Pengajuan IMKP
        </h2>
        <p class="text-white text-xs pl-10">
          Daftar pengajuan IMKP yang dibuat oleh kontraktor
        </p>
      </div>
      <div class="px-10 py-5">
        <div class="grid grid-cols-3 gap-2 items-end mb-4">
          <FormInput
            label="Kontraktor"
            v-model="paramsRequest.keyword"
            placeholder="Masukkan nama kontraktor"
            clearable
            class="w-full col-span-2"
            @keyup.enter="searchKontraktor"
          />
          <FormButton
            label="Cari Kontraktor"
            @click="searchKontraktor"
            classes="bg-red-600 text-white w-full capitalize mb-0.5"
          />
        </div>

        <div class="rounded-lg shadow-md overflow-x-auto">
          <v-data-table-server
            border="0"
            v-model:items-per-page="dataTable.pagination.itemsPerPage"
            :items-per-page-options="[5, 10, 25, 50, 100]"
            :headers="dataTable.headers"
            :items="dataTable.items"
            :loading="dataTable.loading"
            :items-length="dataTable.pagination.totalItems"
            @update:options="getListRequest"
          >
            <template v-slot:item="{ item, index }">
              <tr
                class="border-gray-950 h-16"
                :class="{ 'bg-gray-50': index % 2 !== 0 }"
              >
                <td>{{ getIndexRequest(index) }}</td>
                <td>{{ item.namaKontraktor }}</td>
                <td>{{ item.judulProyek }}</td>
                <td>{{ item.lokasiKerja }}</td>
                <td>{{ formatSubLokasiDisplay(item.subLokasi) }}</td>
                <td>{{ item.keteranganLokasiKerja }}</td>
                <td>
                  <div class="flex gap-2 flex-nowrap py-1">
                    <FormButton
                      label="Tolak"
                      size="small"
                      classes="bg-red-600 text-white capitalize"
                      @click="clickActionRequestIMKP(item.id, 'reject-request')"
                    />
                    <FormButton
                      label="Setuju"
                      size="small"
                      classes="bg-green-600 text-white capitalize"
                      @click="
                        clickActionRequestIMKP(item.id, 'approve-request')
                      "
                    />
                  </div>
                </td>
              </tr>
            </template>
            <template #no-data>
              <div class="py-6 text-center text-gray-500">
                Tidak ada data pengajuan
              </div>
            </template>
          </v-data-table-server>
        </div>
      </div>
    </v-card>
  </v-dialog>

  <ConfirmModal
    v-model="dialogConfirm"
    :img="confirmImg"
    :title="confirmTitle"
    :description="confirmDescription"
    wording-cancel="Batal"
    wording-confirm="Ya"
    @close-modal="closeConfirmModal"
    @confirm-data="onConfirmAction"
  />
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import FormInput from "@/components/FormInput.vue";
import FormButton from "@/components/FormButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import axios from "axios";
import {
  API_BASE_URL,
  CMS_GET_IMKP_REQUEST,
  CMS_SET_IMKP_REQUEST,
} from "@/constants";
import { formatSubLokasiDisplay } from "@/pages/imkp/core/subLokasiHelpers";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import util from "@/assets/js/util";

const url_list_request_imkp = API_BASE_URL + CMS_GET_IMKP_REQUEST;
const url_set_request_imkp = API_BASE_URL + CMS_SET_IMKP_REQUEST;

const REQUEST_TABLE_HEADERS = [
  { title: "No.", key: "index", sortable: false, width: "5%" },
  { title: "Nama Kontraktor", key: "namaKontraktor", sortable: false },
  { title: "Judul Proyek", key: "judulProyek", sortable: false },
  { title: "Lokasi", key: "lokasiKerja", sortable: false },
  { title: "Sub Lokasi", key: "subLokasi", sortable: false },
  {
    title: "Keterangan Lokasi Kerja",
    key: "keteranganLokasiKerja",
    sortable: false,
  },
  { title: "Action", key: "actions", sortable: false, width: "15%" },
];

export default {
  name: "RequestImkpModal",
  mixins: [GlobalDataMixin],
  components: {
    FormInput,
    FormButton,
    ConfirmModal,
  },
  props: {
    modelValue: { type: Boolean, default: false },
    requestCount: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
  emits: [
    "update:modelValue",
    "update:requestCount",
    "update:loading",
    "action-complete",
  ],
  data() {
    return {
      dataTable: CreateDataTableObject(REQUEST_TABLE_HEADERS),
      paramsRequest: {
        page: 0,
        perPage: 5,
        keyword: "",
      },
      dialogConfirm: false,
      pendingAction: {
        id: null,
        action: null,
      },
    };
  },
  computed: {
    confirmTitle() {
      return this.pendingAction.action === "approve-request"
        ? "Setuju Pengajuan IMKP"
        : "Tolak Pengajuan IMKP";
    },
    confirmDescription() {
      const verb =
        this.pendingAction.action === "approve-request"
          ? "menyetujui"
          : "menolak";
      return `Apakah anda yakin akan ${verb} request pengajuan IMKP kontraktor ini?`;
    },
    confirmImg() {
      return this.pendingAction.action === "approve-request"
        ? "approve.png"
        : "reject.png";
    },
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.getListRequest();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    formatSubLokasiDisplay,
    resetForm() {
      this.paramsRequest = { page: 0, perPage: 5, keyword: "" };
      this.dataTable = CreateDataTableObject(REQUEST_TABLE_HEADERS);
      this.closeConfirmModal();
    },
    emitRequestCount(count) {
      this.$emit("update:requestCount", count);
    },
    searchKontraktor() {
      this.paramsRequest.page = 0;
      this.getListRequest();
    },
    async getListRequest({ page, itemsPerPage } = {}) {
      try {
        if (page) {
          this.paramsRequest.page = page - 1;
        }
        if (itemsPerPage) {
          this.paramsRequest.perPage = itemsPerPage;
        }

        this.dataTable.loading = true;

        const res = await axios.get(url_list_request_imkp, {
          params: {
            namaKontraktor: this.paramsRequest.keyword?.trim() || undefined,
            page: this.paramsRequest.page,
            perPage: this.paramsRequest.perPage,
          },
          headers: {
            role: "isafe",
            Authorization: `Bearer ${this.userData.token}`,
            accept: "application/json",
          },
        });

        const header = res.data?.header || {};

        this.paramsRequest.page = header.page ?? 0;
        this.paramsRequest.perPage = header.perPage ?? 5;

        this.dataTable = SetDataTableResponse(this.dataTable, {
          data: res.data?.data || [],
          total_data: header.totalRows ?? 0,
          total_per_page: header.perPage ?? 5,
          current_page: this.paramsRequest.page,
        });

        this.emitRequestCount(header.totalRows ?? 0);
      } catch (err) {
        console.log("ERR getListRequest : ", err);
        util.showError("Terjadi kesalahan saat mengambil data pengajuan IMKP.");
      } finally {
        this.dataTable.loading = false;
      }
    },
    getIndexRequest(index) {
      return (
        index +
        this.paramsRequest.page * this.dataTable.pagination.itemsPerPage +
        1
      );
    },
    clickActionRequestIMKP(id, action) {
      this.pendingAction = { id, action };
      this.dialogConfirm = true;
    },
    closeConfirmModal() {
      this.dialogConfirm = false;
      this.pendingAction = { id: null, action: null };
    },
    onConfirmAction() {
      this.submitActionRequestIMKP(
        this.pendingAction.id,
        this.pendingAction.action,
      );
    },
    async submitActionRequestIMKP(id, action) {
      this.$emit("update:loading", true);
      try {
        await axios.post(
          url_set_request_imkp,
          { id, action },
          {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "application/json",
            },
          },
        );

        util.showInfo("Request pengajuan IMKP berhasil divalidasi!");

        this.closeConfirmModal();
        this.$emit("action-complete");
        this.closeModal();
      } catch (err) {
        console.log("ERR submitActionRequestIMKP : ", err);
        util.showError("Terjadi kesalahan saat validasi pengajuan IMKP.");
      } finally {
        this.$emit("update:loading", false);
      }
    },
    closeModal() {
      this.$emit("update:modelValue", false);
    },
    onDialogVisibility(open) {
      this.$emit("update:modelValue", open);
    },
  },
};
</script>

<style scoped>
:deep(thead) {
  background-color: #fecaca;
}
/* :deep(.v-data-table tbody tr), */
:deep(.v-data-table tbody tr td) {
  border-bottom: none !important;
}
</style>
